import * as React from 'react'

import { Box, Href, Icon, Text } from '@factorialco/deprecated-design-system'

import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

const PaymentSuccessFooter = () => {
  return (
    <Box gap="s32" alignItems="center" textAlign="center" paddingTop="s32">
      <Box gap="s16" alignItems="center" style={{ maxWidth: '540px' }}>
        <Text size="500" weight="semibold" color="grey1000">
          {i18n.t('pricing_plans.success.footer.title')}
        </Text>
        <Text weight="normal" size="300" color="grey800">
          {i18n.t('pricing_plans.success.footer.sentence1')}
          <Text weight="semibold" size="300" color="grey800">
            {i18n.t('pricing_plans.success.footer.sentence2')}
          </Text>
          {i18n.t('pricing_plans.success.footer.sentence3')}
          <Text weight="semibold" size="300" color="grey800">
            {i18n.t('pricing_plans.success.footer.sentence4')}
          </Text>
          {i18n.t('pricing_plans.success.footer.sentence5')}
        </Text>
      </Box>
      <Box flexDirection="row" alignItems="center" justifyContent="center" gap="s4">
        <Icon.Medium icon="info-circle-line" color="grey800" />
        <Href href={helpCenterUrl()} target="_blank">
          <Text weight="semibold" size="200" color="grey1000">
            {i18n.t('pricing_plans.success.footer.actions.help_center')}
          </Text>
        </Href>
      </Box>
    </Box>
  )
}

export default PaymentSuccessFooter
